module.exports = __webpack_public_path__ + "img/img_3.fc8bb73d.png";